import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { getCookieValue } from '../utils/utils';

export const useDisabledGiftCardFlow = (featureSwitchName) => {

  const isFlowDisabledFS = !!useConfigService(featureSwitchName);
  const isFlowDisabledCookie = getCookieValue(featureSwitchName);

  const isFlowDisabled = isFlowDisabledCookie ?? isFlowDisabledFS;
  return {
    isFlowDisabled,
  };
};
